import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Chip,
  Box,
  Typography,
} from "@mui/material";

function getInitials(name) {
  if (!name || typeof name !== "string") {
    return "NJ";
  }

  const parts = name
    .trim()
    .split(" ")
    .filter(Boolean)
    .slice(0, 2);

  if (parts.length === 0) {
    return "NJ";
  }

  return parts.map((part) => part[0]?.toUpperCase() ?? "").join("");
}

function ViewField({ label, value, fullWidth = false }) {
  return (
    <Grid item xs={12} sm={fullWidth ? 12 : 6}>
      <Box
        sx={{
          p: 1.75,
          border: "1px solid #dfe8ef",
          borderRadius: 2.5,
          backgroundColor: "#ffffff",
          height: "100%",
          boxShadow: "0 1px 2px rgba(12, 35, 64, 0.06)",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            display: "block",
            color: "#5d7385",
            mb: 0.5,
            fontWeight: 700,
            letterSpacing: 0.2,
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "#11263a", fontWeight: 600, wordBreak: "break-word" }}
        >
          {value ?? "-"}
        </Typography>
      </Box>
    </Grid>
  );
}

export default function ClientBranchesViewModal({ show, onHide, branchData }) {
  const initials = getInitials(branchData?.ClientBranchName);
  const stateDisplay =
    branchData?.StateName ?? branchData?.stateName ?? branchData?.StateID ?? "-";
  const cityDisplay =
    branchData?.CityName ?? branchData?.cityName ?? branchData?.CityID ?? "-";

  return (
    <Dialog
      open={show}
      onClose={onHide}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: "hidden",
          background:
            "radial-gradient(circle at top right, rgba(53, 99, 140, 0.08) 0%, rgba(53, 99, 140, 0) 35%), #f7fafd",
        },
      }}
    >
      <Box
        sx={{
          px: 3.5,
          py: 2.5,
          background: "linear-gradient(135deg, #15324b 0%, #24605c 100%)",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            sx={{
              width: 52,
              height: 52,
              borderRadius: "50%",
              backgroundColor: "rgba(255,255,255,0.15)",
              border: "1px solid rgba(255,255,255,0.28)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1rem",
              fontWeight: 800,
              letterSpacing: 0.6,
            }}
          >
            {initials}
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
              {branchData?.ClientBranchName || "Detajet e Njësisë së Klientit"}
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.92, mt: 0.35 }}>
              Shikim i të dhënave pa mundësi ndryshimi
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
          <Chip
            size="small"
            label={`ID: ${branchData?.AccountID ?? "-"}`}
            sx={{
              backgroundColor: "rgba(255,255,255,0.18)",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid rgba(255,255,255,0.24)",
            }}
          />
          <Chip
            label={branchData?.IsActive ? "Aktiv" : "Jo Aktiv"}
            color={branchData?.IsActive ? "success" : "default"}
            variant={branchData?.IsActive ? "filled" : "outlined"}
            sx={{
              fontWeight: 800,
              backgroundColor: branchData?.IsActive ? "#2e7d32" : "#dfe5ec",
              color: branchData?.IsActive ? "#fff" : "#394b5a",
            }}
          />
        </Box>
      </Box>

      <DialogContent dividers sx={{ p: 3.5 }}>
        <Box
          sx={{
            p: 2,
            borderRadius: 3,
            border: "1px solid #dfe8ef",
            backgroundColor: "rgba(255,255,255,0.7)",
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{ color: "#1e5560", fontWeight: 800, mb: 1.25, letterSpacing: 0.2 }}
          >
            Informata Kryesore
          </Typography>
          <Grid container spacing={1.5}>
            <ViewField label="Emri i Njësisë" value={branchData?.ClientBranchName} />
            <ViewField label="Emri i Klientit" value={branchData?.AccountName} />
            <ViewField
              label="Numri Identifikues"
              value={branchData?.ClientBranchIdentificationNumber}
            />
            <ViewField label="Shteti" value={stateDisplay} />
            <ViewField label="Qyteti" value={cityDisplay} />
            <ViewField label="Adresa" value={branchData?.ClientBranchAddress} fullWidth />
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3.5, py: 2.25, backgroundColor: "#edf4f8" }}>
        <Button
          onClick={onHide}
          variant="contained"
          sx={{
            background: "linear-gradient(135deg, #1b4e57 0%, #284945 100%)",
            px: 3,
            textTransform: "none",
            fontWeight: 700,
            borderRadius: 2,
            boxShadow: "none",
            "&:hover": {
              background: "linear-gradient(135deg, #163f46 0%, #1f3a36 100%)",
              boxShadow: "none",
            },
          }}
        >
          Mbyll
        </Button>
      </DialogActions>
    </Dialog>
  );
}
